const forms_elements = document.querySelectorAll('.js-product-options-form');
const fields_elements = document.querySelectorAll('.js-product-options-field');
const values_elements = document.querySelectorAll('.js-product-options-value');

export default class ProductOptionsView {
	constructor (options) {
		if (!options || typeof options !== 'object') {
			throw new Error(`The parameter "options" should be of type object, but instead had ${typeof options} type`);
		}
		const {
			product_id,
			el,
			el_price,
			el_price_original,
			discount
		} = options;

		this.selectors = {
			el_price: el_price,
			el_price_original: el_price_original
		};

		this.product_id = product_id;
		this.el = el && document.querySelector(el);
		this.el_price = el_price && document.querySelectorAll(el_price);
		this.el_price_original = el_price_original && document.querySelector(el_price_original);
		this.discount = discount;
		this.forms_elements = forms_elements;
		this.fields_elements = fields_elements;
		this.values_elements = values_elements;
		this.original_price = null;

		if (!this.el_price) {
			throw 'Product options: product price element is undefined!';
		}

		if (this.el && this.el_price.length > 0) {
			this.getPrice();
			this.calculate();
			this.setEventListeners();
			this.cleanDescription();
			document.addEventListener('product-options:collect-data', () => this.dispatchEvents());
			document.addEventListener('[add-to-cart]:rendered', () => this.calculatePrice());
		}
	}

	setEventListeners () {
		this.values_elements.forEach(elem => {
			if (elem && elem.getAttribute('type') === 'checkbox' || elem.getAttribute('type') === 'radio') {
				elem.addEventListener('change', this.calculate.bind(this, elem));
			}
		});
		this.fields_elements.forEach(elem => {
			const select = elem.querySelector('select');

			if (select) {
				elem.addEventListener('change', this.calculate.bind(this, elem));
			}
		});
	}

	calculate (element) {
		this.calculatePrice();
		this.calculateDynamicPrices(element);
	}

	validate () {
		const required_items = this.el.querySelectorAll('[required]');
		required_items.forEach(value => {
			const field = value.closest('.js-product-options-field');

			if (value.value.length === 0) {
				field.classList.add('has-error');
			} else {
				field.classList.remove('has-error');
			}
		});

		if (this.el.classList.contains('has-error')) {
			const error_field = this.el.querySelector('has-error');

			error_field.querySelector('.js-product-options-value').focus();
			return false;
		} else {
			return true;
		}
	}

	getSelectedOptionsData () {
		return [].reduce.call(document.querySelectorAll('.js-product-options-value'), (result, element) => {
			if (element.checked || element.selected) {
				result = [...result, {
					FormDefValId: element.getAttribute('data-form-def-val-id'),
					FormId: element.getAttribute('data-form-id'),
					ValueId: element.getAttribute('data-val-id')
				}];
			}
			return result;
		}, []);
	}

	calculatePrice () {
		let selected_values = [].filter.call(document.querySelectorAll('.js-product-options-field input'), element => element && element.checked);
		const selected_options = [].map.call(document.querySelectorAll('.js-product-options-field select'), element => element.options[element.selectedIndex]);
		selected_values = [...selected_values, ...selected_options];
		const adjustment = selected_values.reduce(function(memo, value) {
			return memo + parseFloat(value.getAttribute('data-price-adjustment'));
		}, 0);
		let adjustment_discounted = 0;

		if (this.discount > 0 && adjustment > 0) {
			adjustment_discounted = adjustment - ( ( adjustment / 100 ) * this.discount );
		}
		this.setPrice(adjustment, adjustment_discounted);
	}

	valuesInputText () {
		return [].reduce.call(this.fields_elements, (result, current) => {
			if (current.getAttribute('data-type') === 'text') {
				let val = current.value;

				if (!val) {
					if (current.querySelector('[data-value]')) {
						val = current.querySelector('[data-value]').getAttribute('data-value');
					}
				}

				result = [...result, {
					Name: current.getAttribute('data-form-field-title'),
					Value: val,
					ShowInCart: current.getAttribute('data-show-in-cart') > 0
				}];
			}
			return result;
		},[]);
	}

	getOriginalPrice () {
		return window.Session.get('ProductInfo')
			.then(info => {
				const { DynamicNumbers: { original_price }} = info;
				return Promise.resolve(original_price);
			})
			.catch(error => {
				console.error(error);
				return Promise.reject(error);
			});
	}

	makeDynamicCalculations (element) {
		if (element && element.getAttribute('type') === 'radio') {
			const parent_block = element.closest('.js-product-options-field');
			const price = parseFloat(element.getAttribute('data-price-adjustment'));

			parent_block.querySelectorAll('input').forEach(item => {
				const item_price = parseFloat(item.getAttribute('data-price-adjustment'));
				const price_value = item.parentNode.querySelector('.j-price, .js-price-adjustment');

				if (price_value) {
					const final_price = (item_price - price).money();
					price_value.textContent = final_price[0] !== '-' ? `+${final_price}` : final_price;
				}
			});
		}
	}

	calculateDynamicPrices (element) {
		if (!this.original_price) {
			this.getOriginalPrice()
				.then(info => {
					this.original_price = info;
					this.makeDynamicCalculations(element);
				});
		} else {
			this.makeDynamicCalculations(element);
		}
	}

	setPrice (adjustment, adjustment_discounted) {
		const el_price = document.querySelectorAll(this.selectors.el_price);

		this.price_current = this.price + adjustment;
		if (adjustment_discounted > 0) {
			this.price_current = this.price + adjustment_discounted;
		}

		el_price.forEach(el => {
			el.textContent = String(this.price_current.money());
		});

		if (this.el_price_original) {
			const price_original = this.price_original + adjustment;
			this.el_price_original.textContent(String(price_original.money()));
		}
	}

	getPrice () {
		this.price = parseFloat(this.el_price[0].getAttribute('data-price'));
		if (this.el_price_original) {
			this.price_original = parseFloat(this.el_price_original[0].getAttribute('data-price'));
		}
	}

	dispatchSelectedOptions () {
		const product_options_selected = new CustomEvent('product-options:selected', { detail: this.getSelectedOptionsData() });
		document.dispatchEvent(product_options_selected);
	}

	dispatchValidateOptions () {
		const product_options_is_valid = new CustomEvent('product-options:is_valid', { detail: this.validate() });
		document.dispatchEvent(product_options_is_valid);
	}

	dispatchManualOptions () {
		const product_manual_options = new CustomEvent('product-options:manual', { detail: this.valuesInputText() });
		document.dispatchEvent(product_manual_options);
	}

	dispatchEvents () {
		this.dispatchSelectedOptions();
		this.dispatchValidateOptions();
		this.dispatchManualOptions();
	}

	// Hide empty descriptions
	cleanDescription () {
		const descriptions = this.el.querySelectorAll('.input-group-description');

		if (descriptions) {
			descriptions.forEach(description => {
				const html = description.innerHTML =  description.innerHTML.replace(/(?:\r\n|\r|\n)/g, '');
				if (html === '<p><br></p>') {
					description.classList.add('hide');
				}
			});
		}
	}
}